import React, { useEffect, useState } from 'react';
import {
    Alert,
    Button,
    ButtonGroup,
    Card,
    Col,
    Container,
    Dropdown,
    Form,
    Image,
    Row,
    Spinner,
    Stack,
} from 'react-bootstrap';
import camera from '../../Assets/Img/camera.png';
import avatar from '../../Assets/Img/avatar.png';
import './profile.scss';
import { CircleUserRound, Plus } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
    useEditProfileMutation,
    useProfileImageUploadMutation,
    useProfilePasswordChangeMutation,
} from './profileApi';
import LoadingComponent from '../LoadingComponent';
import Config from '../../Api/config';
import { formatDate, validatePassword } from '../../helper';
import { useGetprofileMutation } from '../Login/loginApi';
import { usePatientListMutation } from '../Patient/patientApi';
import { setSecureItem, getSecureItem } from "../../utils/secureStorage";

const Profile = () => {
    const { t } = useTranslation();
    const { state } = useLocation();
    console.log(state, 'statestate');

    const maxDateValidation = new Date().toISOString().split('T')[0];
    const user = getSecureItem('UserData');
    const [profileData, setProfileData] = useState({
        ...state?.userData,
        is2FaActive:
            state?.userData?.is2FaActive === true ||
            state?.userData?.is2FaActive === "true",
        dateOfBirth: formatDate(state?.userData?.dateOfBirth),
    });

    useEffect(() => {
        console.log('profileData =======================> ', profileData);
    }, [profileData]);

    const [showChangePassword, setShowChangePassword] = useState(false);
    const [passwordMatchError, setPasswordMatchError] = useState('');
    const [passwordValidation, setPasswordValidation] = useState('');
    const [error, setError] = useState('');
    const [buttonLoading, setButtonLoading] = useState(false);
    const [passwordChangeConfig, setPasswordChangeConfig] = useState({
        oldPassword: '',
        newPassword: '',
        confirmNewPassword: '',
    });
    const [loading, setLoading] = useState(true);
    const config = {
        email: '',
        mobile: '',
        search: '',
        pageSize: 50,
        pageNumber: 1,
        startDate: '',
        endDate: '',
    };
    const navigate = useNavigate();
    const [imageUpload] = useProfileImageUploadMutation();
    const [passwordChange] = useProfilePasswordChangeMutation();
    const [getProfile] = useGetprofileMutation();
    const [editProfile] = useEditProfileMutation();
    const [patientList] = usePatientListMutation();

    useEffect(() => {
        if (loading) {
            if (!state?.editable) {
                let tempData = {
                    email: state?.userData,
                    mobile: '',
                    search: '',
                    pageSize: 50,
                    pageNumber: 1,
                    startDate: '',
                    endDate: '',
                };
                patientList({ ...tempData }).then(
                    ({ data: { userProfileData } }) => {
                        console.log(userProfileData[0]);
                        setProfileData({
                            ...userProfileData[0],
                            is2FaActive:
                                userProfileData[0]?.is2FaActive === true ||
                                userProfileData[0]?.is2FaActive === "true",
                            dateOfBirth: formatDate(userProfileData[0]?.dateOfBirth),
                        });
                        setLoading(false);
                    }
                );
            } else {
                setLoading(false);
            }
        }
    }, [loading]);

    const uploadImage = async (e) => {
        setLoading(true);
        let formData = new FormData();
        formData.append('UserEmail', profileData?.email);
        formData.append('ProfileImage', e.target.files[0]);
        console.log(formData, 'formDataformData');

        let { data } = await imageUpload(formData);
        if (data) {
            setLoading(false);
        }
    };

    const handlePasswordChange = (e) => {
        setPasswordChangeConfig((prevValues) => {
            return {
                ...prevValues,
                [e.target.name]: e.target.value,
            };
        });
    };

    const changePassword = async () => {
        setError('');
        if (!validatePassword(passwordChangeConfig?.newPassword)) {
            setPasswordValidation(t('passwordValidation'));
            return;
        }
        if (
            passwordChangeConfig?.newPassword !==
            passwordChangeConfig?.confirmNewPassword
        ) {
            setPasswordMatchError(t('passwordNotMatch'));
            setPasswordValidation(t(''));
            return;
        }
        setButtonLoading(true);
        setPasswordMatchError(t(''));
        setPasswordValidation(t(''));
        let result = await passwordChange(passwordChangeConfig);
        console.log(result.error.data);
        if (result.error.data == 'success') {
            setButtonLoading(false);
        }
        if (result.error.data == 'Old password is invalid') {
            setError(result.error.data);
            setButtonLoading(false);
        }
    };

    const editHandle = async () => {
        setButtonLoading(true);
        let result = await editProfile(profileData);
        console.log(result, 'result');
        await getProfile().then((userData) => {
            console.log(userData, 'userData');

            setProfileData({
                ...userData.data,
                is2FaActive:
                    userData.data?.is2FaActive === true ||
                    userData.data?.is2FaActive === "true",
            });

            setSecureItem("UserData", userData.data);
            setSecureItem("ExternalOptician", userData.data.isExternal);
            setButtonLoading(false);
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);

        setProfileData((prevValues) => {
            const updatedValues = { ...prevValues, [name]: value };
            // if (name === "dateOfBirth" && getAge(value)) {
            //     console.log(getAge(value))
            //     updatedValues.age = getAge(value).toString();
            // }
            if (name === "is2FaActive") {
                updatedValues.is2FaActive =
                    value === true || value === "true";
            }
            if (name === 'doYouWearGlasses') {
                updatedValues.doYouWearGlasses = value == 'true' ? true : false;
            }
            if (name === 'infoPrescriptionToOptician') {
                updatedValues.infoPrescriptionToOptician =
                    value == 'true' ? true : false;
            }
            if (name === 'isDoctorExpressAvailable') {
                updatedValues.isDoctorExpressAvailable = value == 'true' ? true : false;
            }
            return updatedValues;
        });
    };

    return (
        <>
            {loading ? <LoadingComponent /> : ''}
            <Container fluid>
                <Row className="mb-3">
                    <div className="d-flex p-0 gap-3 justify-content-end">
                        {user?.userType == profileData?.userType ? (
                            <>
                                {state?.editable ? (
                                    <Button
                                        onClick={editHandle}
                                        disabled={
                                            !state?.editable || buttonLoading
                                        }
                                    >
                                        {buttonLoading && (
                                            <Spinner
                                                animation="border"
                                                role="status"
                                                size="sm"
                                            >
                                                <span className="visually-hidden">
                                                    Loading...
                                                </span>
                                            </Spinner>
                                        )}{' '}
                                        {t('saveChanges')}
                                    </Button>
                                ) : (
                                    ''
                                )}
                            </>
                        ) : (
                            ''
                        )}
                    </div>
                </Row>
            </Container>
            <Container
                fluid
                className={`${!state?.editable ? 'custom_disabled' : ''}`}
            >
                <div className="profile_header">
                    <Card className="mb-4">
                        <Card.Body className="modal_form">
                            <h5 className="fw-semibold mb-4">
                                {t('nameAndPicTitle')}
                            </h5>
                            <div className="profile_image mb-4">
                                {profileData?.profileImagePath !== '' ? (
                                    <Image
                                        src={`${Config.img_URL}/${profileData?.profileImagePath}`}
                                    />
                                ) : (
                                    <CircleUserRound width={120} height={120} />
                                )}
                                <div
                                    role="button"
                                    className="image_upload_button"
                                >
                                    <Form.Control
                                        type="file"
                                        onChange={uploadImage}
                                    />
                                    <img
                                        src={camera}
                                        style={{
                                            height: '24px',
                                            width: '24px',
                                        }}
                                    />
                                </div>
                            </div>
                            <Row className="">
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('firstName')}
                                        </Form.Label>
                                        <Form.Control
                                            value={profileData?.name}
                                            type="text"
                                            name="name"
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('surName')}</Form.Label>
                                        <Form.Control
                                            value={profileData?.lastName}
                                            type="text"
                                            name="lastName"
                                            onChange={handleChange}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                {profileData?.userType === 'PATIENT' ? (
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('doesSubjectWearGlasses')}
                                            </Form.Label>
                                            <Form.Select
                                                aria-label="Default"
                                                name="doYouWearGlasses"
                                                onChange={handleChange}
                                                value={
                                                    profileData?.doYouWearGlasses
                                                }
                                                required
                                            >
                                                <option disabled value={''}>
                                                    {t('selectItem')}
                                                </option>
                                                <option value={true}>
                                                    {t('yes')}
                                                </option>
                                                <option value={false}>
                                                    {t('no')}
                                                </option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                ) : (
                                    ''
                                )}

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('email')}</Form.Label>
                                        <Form.Control
                                            value={profileData?.email}
                                            type="email"
                                            name="email"
                                            required
                                            disabled
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
                <div className="profile_details">
                    <Card className="mb-4">
                        <Card.Body className="modal_form">
                            <h5 className="fw-semibold mb-4">
                                {t('personalInformation')}
                            </h5>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label>{t('userType')}</Form.Label>
                                        <Form.Select
                                            aria-label="Default"
                                            name="userType"
                                            required
                                            disabled
                                        >
                                            <option value="">
                                                {profileData?.userType}
                                            </option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {t('dateofBirth')}
                                        </Form.Label>
                                        <Form.Control
                                            onChange={handleChange}
                                            max={maxDateValidation}
                                            value={profileData?.dateOfBirth}
                                            type="date"
                                            name="dateOfBirth"
                                            placeholder={t('inputText')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('phone')}</Form.Label>
                                        <Form.Control
                                            onChange={handleChange}
                                            value={profileData?.mobile}
                                            type="tell"
                                            name="mobile"
                                            placeholder={t('inputText')}
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>{t('address')}</Form.Label>
                                        <Form.Control
                                            value={
                                                profileData?.doctorAddressOfTheHealthCenter
                                            }
                                            onChange={handleChange}
                                            type="text"
                                            name="doctorAddressOfTheHealthCenter"
                                            required
                                        />
                                    </Form.Group>
                                </Col>
                                {/* 2FA Settings - Admin Only */}
                                {profileData?.userType === "ADMIN" && (
                                    <>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>2FA Enabled</Form.Label>
                                                <Form.Select
                                                    name="is2FaActive"
                                                    value={profileData?.is2FaActive ? "true" : "false"}
                                                    onChange={(e) =>
                                                        handleChange({
                                                            target: {
                                                                name: "is2FaActive",
                                                                value: e.target.value === "true",
                                                            },
                                                        })
                                                    }
                                                >
                                                    <option value="false">{t("no")}</option>
                                                    <option value="true">{t("yes")}</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                        {profileData?.is2FaActive && (
                                            <Col md={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>Secondary Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="adminSecondaryEmail2Fa"
                                                        value={profileData?.adminSecondaryEmail2Fa || ""}
                                                        onChange={handleChange}
                                                        required={profileData?.is2FaActive}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </>
                                )}
                                {profileData?.userType === "EYEDOCTOR" && (
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>{t('expressTest')}</Form.Label>
                                            <Form.Select
                                                name="isDoctorExpressAvailable"
                                                onChange={handleChange}
                                                value={
                                                    profileData?.isDoctorExpressAvailable?.toString()
                                                }
                                            >
                                                <option value="false">{t('no')}</option>
                                                <option value="true">{t('yes')}</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                )}

                                {profileData?.userType === 'PATIENT' ? (
                                    <>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('additionalComments')}
                                                </Form.Label>
                                                <Form.Control
                                                    value={
                                                        profileData?.additionalComments
                                                    }
                                                    onChange={handleChange}
                                                    type="text"
                                                    name="additionalComments"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    {t('ssnNumber')}
                                                </Form.Label>
                                                <Form.Control
                                                    value={profileData?.infoSSN}
                                                    onChange={handleChange}
                                                    type="text"
                                                    name="infoSSN"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </>
                                ) : (
                                    ''
                                )}

                                {/* Automatic prescription sharing field for PATIENT users */}
                                {profileData?.userType === 'PATIENT' ? (
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label style={{ whiteSpace: 'normal' }}>
                                                {t('sharePrescriptionToOptician')}
                                            </Form.Label>
                                            <Form.Select
                                                value={profileData?.infoPrescriptionToOptician?.toString()}
                                                name="infoPrescriptionToOptician"
                                                onChange={handleChange}
                                                aria-label="Default select example"
                                            >
                                                <option value="true">{t('yes')}</option>
                                                <option value="false">{t('no')}</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                ) : null}
                            </Row>
                        </Card.Body>
                    </Card>
                </div>
                {user.userType === profileData?.userType && (
                    <div className="profile_password">
                        <Card className="mb-4">
                            <Card.Body className="modal_form">
                                <Stack
                                    direction="horizontal"
                                    gap={3}
                                    className="mb-3"
                                >
                                    <h5 className="fw-semibold mb-4">
                                        {t('changepassword')}
                                    </h5>

                                    <div className="ms-auto">
                                        {showChangePassword ? (
                                            <>
                                                <ButtonGroup>
                                                    <Button
                                                        style={{
                                                            width: 'fit-content',
                                                        }}
                                                        variant="light"
                                                        onClick={() => {
                                                            setShowChangePassword(
                                                                false
                                                            );
                                                            setButtonLoading(
                                                                false
                                                            );
                                                        }}
                                                    >
                                                        {t('cancel')}
                                                    </Button>
                                                    <Button
                                                        variant="primary"
                                                        onClick={changePassword}
                                                        disabled={buttonLoading}
                                                    >
                                                        {buttonLoading && (
                                                            <Spinner
                                                                animation="border"
                                                                role="status"
                                                                size="sm"
                                                            >
                                                                <span className="visually-hidden">
                                                                    Loading...
                                                                </span>
                                                            </Spinner>
                                                        )}{' '}
                                                        {t('addNewSheet')}
                                                    </Button>
                                                </ButtonGroup>
                                            </>
                                        ) : (
                                            <Button
                                                style={{ width: 'fit-content' }}
                                                onClick={() =>
                                                    setShowChangePassword(true)
                                                }
                                            >
                                                {t('changepassword')}
                                            </Button>
                                        )}
                                    </div>
                                </Stack>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>
                                                {t('oldPassword')}
                                            </Form.Label>
                                            <Form.Control
                                                value={
                                                    passwordChangeConfig.oldPassword
                                                }
                                                type="text"
                                                name="oldPassword"
                                                onChange={handlePasswordChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    {showChangePassword ? (
                                        <>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>
                                                        {t('newPassword')}
                                                    </Form.Label>
                                                    <Form.Control
                                                        value={
                                                            passwordChangeConfig.newPassword
                                                        }
                                                        type="text"
                                                        name="newPassword"
                                                        onChange={
                                                            handlePasswordChange
                                                        }
                                                        required
                                                    />
                                                    {passwordValidation !==
                                                        '' && (
                                                            <Form.Text className="text-danger">
                                                                {passwordValidation}
                                                            </Form.Text>
                                                        )}
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group className="mb-3">
                                                    <Form.Label>
                                                        {t('retypenewPassword')}
                                                    </Form.Label>
                                                    <Form.Control
                                                        value={
                                                            passwordChangeConfig.confirmNewPassword
                                                        }
                                                        type="text"
                                                        name="confirmNewPassword"
                                                        onChange={
                                                            handlePasswordChange
                                                        }
                                                        required
                                                    />
                                                    {passwordMatchError !==
                                                        '' && (
                                                            <Form.Text className="text-danger">
                                                                {passwordMatchError}
                                                            </Form.Text>
                                                        )}
                                                </Form.Group>
                                            </Col>
                                        </>
                                    ) : (
                                        ''
                                    )}
                                    {error !== '' && (
                                        <Col md={12}>
                                            <Alert variant={'danger'}>
                                                {error}
                                            </Alert>
                                        </Col>
                                    )}
                                </Row>
                            </Card.Body>
                        </Card>
                    </div>
                )}
            </Container>
        </>
    );
};

export default Profile;